<template>
  <Transition name="dialog-fade">
    <div v-if="isOpen" class="dialog-ui is-active" role="alertdialog" aria-modal="true">
      <div class="dialog-dim"></div>
      <div class="dialog-inner">
        <div class="dialog-body" v-html="message"></div>
        <div class="dialog-footer button-area">
          <AppButton 
            v-if="type === 'confirm'"
            class="tp-gray btn-cancel"
            type="button"
            variant="outline" 
            size="md"
            block
            @click="handleAction(false)"
          >
           {{ cancelText }}
          </AppButton>
          <AppButton 
            class="tp-gray btn-confirm"
            type="button"
            variant="primary" 
            size="md"
            block
            @click="handleAction(true)"
          >
           {{ confirmText }}
          </AppButton>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import AppButton from './AppButton.vue';

const props = defineProps({
  isOpen: Boolean,
  type: String,
  message: String,
  confirmText: { type: String, default: '확인' },
  cancelText: { type: String, default: '취소' },
  resolve: Function // Promise 해결용
})

const handleAction = (result) => {
  props.resolve(result)
}
</script>